import React, { useState, useEffect } from "react";
import ConfirmDialog from "./ConfirmDialog.jsx";

let resolver = null;
export function confirmDialog(opts = {}) {
  return new Promise((resolve) => {
    resolver = resolve;
    const detail = typeof opts === "string" ? { description: opts } : opts;
    window.dispatchEvent(new CustomEvent("fw40-confirm", { detail }));
  });
}

export default function ConfirmHost() {
  const [state, setState] = useState(null);
  useEffect(() => {
    const h = (e) => setState(e.detail || {});
    window.addEventListener("fw40-confirm", h);
    return () => window.removeEventListener("fw40-confirm", h);
  }, []);
  if (!state) return null;
  const done = (val) => { const r = resolver; resolver = null; setState(null); if (r) r(val); };
  return (
    <ConfirmDialog
      open={true}
      title={state.title || "Potvrdit akci"}
      description={state.description || ""}
      confirmLabel={state.confirmLabel || "Potvrdit"}
      cancelLabel={state.cancelLabel === null ? null : (state.cancelLabel || "Zrušit")}
      variant={state.variant || "danger"}
      onConfirm={() => done(true)}
      onCancel={() => done(false)}
    />
  );
}
